<template>
  <page layout="tabbed">
    <page-header-new :title="pageTitle">
      <template slot="actions">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="createTemplateCampaign"
          v-if="$can('createProjectItem') && !isEmbeddedPage"
        >
          {{ $t('Template_CampaignsPage_CreateTemplate_Btn') }}
        </el-button>
      </template>
    </page-header-new>
    <div v-if="isStandalone" class="standalone-content">
      <router-view />
    </div>
    <page-tabs v-else :tabs="tabs" />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'
import { isEmbedded } from '@/core/utils/EmbeddedPage'
export default {
  name: 'TemplateCampaignsPage',
  components: { PageTabs, PageHeaderNew, Page },
  methods: {
    createTemplateCampaign() {
      this.$router.push(projectRoute({ name: 'CreateTemplateCampaign' }))
    }
  },
  computed: {
    isEmbeddedPage() {
      return isEmbedded()
    },
    isStandalone() {
      return 'standalone' in this.$route.query
    },
    pageTitle() {
      if (this.$store.getters.embeddedTitle) {
        return this.$store.getters.embeddedTitle
      }
      return this.isStandalone
        ? this.$t('Campaign_TemplatesPage_PreMade_Title')
        : this.$t('Campaign_TemplatesPage_Title')
    },
    tabs() {
      return [
        {
          title: this.$t('Template_CampaignsPage_Tab_Custom'),
          route: projectRoute({ name: 'TemplateCampaignsTab' })
        },
        {
          title: this.$t('Template_CampaignsPage_Tab_PreMade'),
          route: projectRoute({ name: 'PreMadeTemplatesTab' })
        }
      ]
    }
  }
}
</script>

<style scoped>
.standalone-content {
  padding: 22px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/TemplateCampaignsPage.vue